import React, {useEffect} from "react";
import {useHistory, useLocation} from "react-router-dom";
import {Box} from "@material-ui/core";
import Breadcrumb from "../../design-system/components/Breadcrumb/Breadcrumb";
import Tabs from "../../design-system/components/Tabs/Tabs";

import Button from "@material-ui/core/Button";
import AddIcon from "@material-ui/icons/Add";
import Credentials from "./Procesos/MgmtCredentials";
import Microcredentials from "./Procesos/MgmtMicrocredentials";
import Catalogs from "./Catalogos/Catalogs";

const TABS = ['Enviados','Microcredenciales','Catálogos'];

const ITEMS = [{to: '/Home', label: 'Administrador', title: ''}, {
    to: '/thinkific',
    label: 'Gestion de credenciales Thinkific',
    title: ''
},];




const Thinkific = (props) => {

    const [tabsProps, setTabsProps] = React.useState({tabs: TABS, activeTab: 0});
    const [items, setItems] = React.useState(ITEMS);
    const [showTabs, setShowTabs] = React.useState(true)

    const location = useLocation();
    const history = useHistory();


    useEffect(() => {
        const searchParams = new URLSearchParams(location.search);
        const tabParam = searchParams.get('tab');
        if (tabParam !== null) {
            const tabIndex = parseInt(tabParam);
            if (tabIndex >= 0 && tabIndex < TABS.length) {
                setTabsProps({tabs: TABS, activeTab: tabIndex});
            }
        }
    }, [location.search]);

    const handleChangeTab = activeTab => {
        if (activeTab === 1) {
            history.push('/thinkific?tab=1');
        } else {
            history.push('/thinkific');
        }
        setTabsProps({tabs: TABS, activeTab});
    };

     return (<Box>
        <Breadcrumb items={items} />
        <Box>
            <Tabs
                onChange={handleChangeTab}
                {...tabsProps}
                style={{display: showTabs ? "flex" : "none"}}
            >
                {tabsProps.activeTab === 0 && <Credentials setShowTabs={setShowTabs} setBreadCrumbs={setItems}/>}
                {tabsProps.activeTab === 1 && <Microcredentials setShowTabs={setShowTabs} setBreadCrumbs={setItems}/>}
                {tabsProps.activeTab === 2 && <Catalogs setShowTabs={setShowTabs} setBreadCrumbs={setItems}/>}
         
            </Tabs>
        </Box>
    </Box>)
}

export default Thinkific;
